(function () {
  const storeKey = 'wishlist_ids';

  const boot = window.WISHLIST_BOOT || {};
  const isLoggedIn = !!boot.loggedIn;
  const proxyBase = boot.proxyBase || '/apps/wishlist';

  // --- LocalStorage helpers ---
  function readLocal() {
    try { return JSON.parse(localStorage.getItem(storeKey) || '[]'); }
    catch { return []; }
  }
  function writeLocal(arr) {
    localStorage.setItem(storeKey, JSON.stringify([...new Set(arr.map(String))]));
  }
  function getState() { return new Set(readLocal().map(String)); }

  // --- UI helpers ---
  function setPressed(btn, active) {
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    const icon = btn.querySelector('.js-wishlist-icon');
    // if (icon) icon.textContent = active ? '❤' : '❤';
    btn.title = active ? 'お気に入りから削除' : 'お気に入りに追加';
  }
  function refreshButtons() {
    const state = getState();
    document.querySelectorAll('.js-wishlist-btn').forEach(btn => {
      const id = (btn.getAttribute('data-product-id') || '').toString();
      setPressed(btn, state.has(id));
    });
  }

  // --- Network helper ---
  async function fetchJSON(url, opts) {
    const res = await fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    }, opts));
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    return res.json();
  }

  // --- Initial sync (login時はlocalとメタフィールドをマージ保存) ---
  async function initState() {
    const local = readLocal();

    if (!isLoggedIn) {
      // 未ログイン：初期状態は local のみ
      return writeLocal(local), refreshButtons();
    }

    // ログイン：App Proxy へ同期
    try {
      const payload = {
        customerGID: boot.customerGID,
        productIds: (local.length ? local : (boot.initialIds || [])).map(String)
      };
      const data = await fetchJSON(`${proxyBase}/sync`, {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      // サーバーの正と一致させる
      writeLocal((data.productIds || []).map(String));
    } catch (e) {
      console.warn('Wishlist init sync failed:', e);
      // 失敗してもlocalはそのまま使う
    }
    refreshButtons();
  }

  // --- 効果測定用: GA4イベント送信（theme.liquid のブリッジが gtag('event') へ転送） ---
  // 計測実装タスク 2026-08 / T2（お気に入りのGA4計測）
  function contextOf(btn) {
    if (!btn) return 'unknown';
    const explicit = btn.getAttribute('data-wishlist-context');
    if (explicit) return explicit;
    const sec = btn.closest('[data-section-type]');
    return (sec && sec.getAttribute('data-section-type')) || 'unknown';
  }
  function track(active, productId, btn) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: active ? 'add_to_wishlist' : 'remove_from_wishlist',
        item_id: String(productId),
        item_handle: (btn && btn.getAttribute('data-product-handle')) || '',
        item_name: (btn && btn.getAttribute('data-product-title')) || '',
        wishlist_context: contextOf(btn)
      });
    } catch (e) { /* 計測失敗で機能を止めない */ }
  }

  // --- Toggle (UI→local保存→必要ならApp Proxyへ反映) ---
  async function toggle(productId, btn) {
    const id = String(productId);
    const arr = readLocal().map(String);
    const i = arr.indexOf(id);
    const added = i < 0;
    if (i >= 0) arr.splice(i, 1); else arr.push(id);
    writeLocal(arr);
    refreshButtons();
    track(added, id, btn);

    if (isLoggedIn) {
      // 非同期でサーバーへ反映（失敗しても次回syncで整合）
      try {
        await fetchJSON(`${proxyBase}/toggle`, {
          method: 'POST',
          body: JSON.stringify({ customerGID: boot.customerGID, productId: id })
        });
      } catch (e) {
        console.warn('Wishlist toggle save failed:', e);
      }
    }
  }

  // --- Events ---
  document.addEventListener('click', e => {
    const btn = e.target.closest('.js-wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.getAttribute('data-product-id'), btn);
  });

  document.addEventListener('DOMContentLoaded', initState);
})();
